import { compatibleOpenQQQun } from '@/lib/compatible';
import ModalInstance from '@/modules/modal/ModalInstance';

export default {
	/**
	 * @description: 做任务
	 * @param {object} task - 任务信息
	 * @param {string} videoAppPosition - 视频任务触发位置，用作埋点
	 */

	async doTask(task, videoAppPosition = '任务列表', activityPosition) {
		const { task_type, button_link, status, button_txt, third_part_name, link_type, back_mode, disclaimer } = task;

		// 更新全局活动入口位置
		this.$store.commit('updateActivityPos', activityPosition);

		// 单独处理头条内容 SDK
		if (new RegExp('^headlines').test(task_type)) {
			const url = button_link.replace('kuaiyin:/', '');
			this.$sdk.openNativePage(url);
			return;
		}

		// 单独处理变现猫
		if (new RegExp('^cash_out_cat').test(task_type)) {
			this.handleGameBxm(task);
			return;
		}

		// 单独处理小满
		if (new RegExp('^xiaoman').test(task_type)) {
			const uid = this.$sdk.getUserInfo().uid;
			const url = `${button_link}&consumerId=${uid}`;

			if (url) {
				this.openPage(url, null, back_mode, third_part_name, link_type);
			}
			return;
		}

		// 单独处理赋能小游戏
		if (new RegExp('^fu_neng').test(task_type)) {
			this.$sdkNew.appCall('OPEN_FU_NENG_GAME', button_link);
			return;
		}

		switch (task_type) {
			case 'banner_tuia': // 推啊的 banner 广告
				this.openPage(button_link);
				break;
			case 'watch_video': // 刷短视频
				let url = '';
				if (this.platform === 'ios') {
					url = 'kuaiyin://app/short_video';
				} else {
					url = button_link;
				}
				this.openPage(url);
				break;
			case (task_type.match(/^game_shandw/) || {}).input: // 闪电玩 H5 游戏
				this.handleShanDWTask(task);
				break;
			case 'qq_qun': // 更多现金任务
				this.openQQ(623966639);
				break;
			case 'read_free_novel': // 谷雨小说
				const data = {
					url: 'openGuYuNovel',
					third_part_name: third_part_name,
					link_type: link_type,
				};
				await this.$sdk.openGuYuNovel(JSON.stringify(data));
				break;
			case 'read_free_novel_h5': // 更多现金任务
				this.openPage(button_link, null, 'close', third_part_name, link_type);
				break;
			case 'play_game': // 福利游戏，多有游戏列表，带有 advert_id 的单个游戏
				if (window.bridge) {
					if (window.bridge.openTipAdGame) {
						const data = {
							url: button_link,
							third_part_name: third_part_name,
							link_type: link_type,
						};
						this.$sdk.openTipAdGame(JSON.stringify(data));
					}
				} else {
					this.openPage(button_link, null, 'close', third_part_name, link_type);
				}
				break;
			case 'view_video': // 看广告视频得金币
				// 如果任务列表看视频今日已看完，则弹出视频已看完的奖励弹窗
				if (+status === 1 && button_txt === '已完成') {
					this.showCompleteModal();
					return;
				}
				const { task_record_id, ad_info_group, ad_platform_status } = task;
				const trackParams = {
					element_name: '看视频得金币',
				};
				const video = {
					master: {},
					fill: {},
					task_record_id,
					task_type,
					app_position: videoAppPosition,
					trackParams,
					ad_info_group,
					ad_platform_status,
				};

				// 标记当前视频位置
				this.$store.commit('setVideoPos', 'taskList');

				// 注册当前激励视频回调方法
				this.registerVideoCallback(this.videoEndCallback, this);

				// 观看激励视频
				this.watchRewardVideo(video);
				break;
			case 'sign_in_app':
				this.handleSign();
				break;
			case 'guess_music_lucky':
				this.$sdk.pauseMusic();
				if (button_link) {
					this.openPage(button_link, null, 'close', third_part_name, link_type);
				}
				break;
			case 'first_invite_friend':
				if (button_link) {
					this.popFirstInviteModal();
				}
				break;
			case 'remind_click':
				this.handlePushTask(task);
				break;
			case 'store_praise':
				this.handleStorePraise(task);
				break;
			case 'big_turntable':
				this.openFortune();
				break;
			default:
				if (button_link) {
					this.openPage(button_link, null, back_mode, third_part_name, link_type);
				}
				break;
		}
	},

	/**
	 * @description: 打开 QQ 群
	 */

	openQQ(qqCode) {
		this.$sdk.copy(qqCode);
		this.trackClick({ element_name: '复制QQ群号', remarks: qqCode });
		const QQMap = {
			933247468: {
				url: 'mqqopensdkapi://bizAgent/qm/qr?url=http%3A%2F%2Fqm.qq.com%2Fcgi-bin%2Fqm%2Fqr%3Ffrom%3Dapp%26p%3Dandroid%26k%3DYuIrpXIJpIOd4YqqNbs-UAJQJNmVn38e',
			},
			1085876606: {
				url: 'mqqopensdkapi://bizAgent/qm/qr?url=http%3A%2F%2Fqm.qq.com%2Fcgi-bin%2Fqm%2Fqr%3Ffrom%3Dapp%26p%3Dandroid%26k%3DtK8Sa04UBdLe1MGugF_VTlYd0toss-1X',
			},
			860288847: {
				url: 'mqqopensdkapi://bizAgent/qm/qr?url=http%3A%2F%2Fqm.qq.com%2Fcgi-bin%2Fqm%2Fqr%3Ffrom%3Dapp%26p%3Dandroid%26k%3DSjWbJ_MVM3myqe9_j7wBTh50t9UvQLlJ',
			},
			652646379: {
				url: 'mqqopensdkapi://bizAgent/qm/qr?url=http%3A%2F%2Fqm.qq.com%2Fcgi-bin%2Fqm%2Fqr%3Ffrom%3Dapp%26p%3Dandroid%26k%3Dd6bBGU2Skzrwzf7OBzy1H9LE24yXtNM6',
			},
			623966639: {
				url: 'mqqopensdkapi://bizAgent/qm/qr?url=http%3A%2F%2Fqm.qq.com%2Fcgi-bin%2Fqm%2Fqr%3Ffrom%3Dapp%26p%3Dandroid%26k%3DusuTPehCZ9oSQjM192O1OHIENxsjTPAH',
			},
			817538831: {
				url: 'mqqopensdkapi://bizAgent/qm/qr?url=http%3A%2F%2Fqm.qq.com%2Fcgi-bin%2Fqm%2Fqr%3Ffrom%3Dapp%26p%3Dandroid%26k%3DC-h-Xn6hVZqcuAvx-f8JMTie5464RZcI',
			},
		};
		const openQQData = QQMap[String(qqCode)];

		compatibleOpenQQQun(openQQData);
	},

	/**
	 * @description: 展示看视频得金币完成弹窗
	 * @return: void
	 */

	showCompleteModal() {
		const completeModal = new ModalInstance(complete_modal);

		this.completeModalInstance = new completeModal({
			title: '今日视频奖励已全部领取',
			topButton: {
				label: '去领取翻倍金币再赚225.76元',
				onClick: () => {
					this.openPage('/invite_friend');
					this.completeModalInstance.close();
					this.completeModalInstance = null;
				},
			},
			bottomButton: {
				label: '领取225.76元',
				onClick: () => {
					this.openPage('/invite_friend');
					this.completeModalInstance.close();
					this.completeModalInstance = null;
				},
			},
			onClose: () => {
				this.completeModalInstance = null;
			},
		});
	},

	/**
	 * @description: 提示新人邀请弹窗
	 * @return: void
	 */

	popFirstInviteModal() {
		const firstInviteModal = new ModalInstance(first_invite_modal);

		this.firstInviteModalInstance = new firstInviteModal({
			button: {
				label: '立即邀请',
				onClick: () => {
					this.$sdk.share.weixin();
					this.firstInviteModalInstance.close(true);
				},
			},
			onClose: () => {
				this.firstInviteModalInstance = null;
			},
		});
	},

	/**
	 * @description: 处理变现猫游戏
	 */

	handleGameBxm(data) {
		const { ad_id } = data;
		this.$sdk.openBxmGame(ad_id);
	},
};



// WEBPACK FOOTER //
// ./src/root/historyTask.js